/**
 * Runtime configuration. Loaded from window.__CUSTOMER_CONFIG__ injected by
 * /config.js at deploy time. Falls back to dev defaults so `npm run dev`
 * works out of the box.
 */
export interface CustomerConfig {
  /** Base URL of the tenant-mgmt HTTP API (no trailing slash). */
  apiBaseUrl: string;
  /** Base URL del flow-engine HTTP API. */
  apiBaseUrlFlow: string;
  /** Base URL del reporting-api HTTP API. */
  apiBaseUrlReporting: string;
  /** Cognito hosted UI domain (no trailing slash). */
  cognitoDomain: string;
  /** Cognito user pool client ID. */
  cognitoClientId: string;
  /** Callback URL registered in Cognito for this SPA. */
  redirectUri: string;
  /** Logout URL Cognito should redirect to after logout. */
  logoutUri: string;
  /** Environment label, shown in the topbar. */
  envLabel: string;
  /**
   * Dev-only override: forzar un slug cuando no hay subdomain real.
   * En qa/prod queda null y el slug se extrae de window.location.hostname.
   */
  tenantSlugOverride: string | null;
}

declare global {
  interface Window {
    __CUSTOMER_CONFIG__?: Partial<CustomerConfig>;
  }
}

const defaults: CustomerConfig = {
  apiBaseUrl: 'https://1zwzz5s116.execute-api.us-east-2.amazonaws.com',
  apiBaseUrlFlow: 'https://xkj1y85c7c.execute-api.us-east-2.amazonaws.com',
  apiBaseUrlReporting: 'http://localhost:3000',
  cognitoDomain: 'https://zen-dev-auth.auth.us-east-2.amazoncognito.com',
  cognitoClientId: '4mr4vrvcvklm81m8gp2mb2eb72',
  redirectUri: `${window.location.origin}/callback`,
  logoutUri: window.location.origin,
  envLabel: 'dev',
  tenantSlugOverride: null,
};

export const config: CustomerConfig = {
  ...defaults,
  ...(window.__CUSTOMER_CONFIG__ ?? {}),
};
